'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRedeem = function MdRedeem(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.4 23.4v-10h-8.6l3.6 4.6-2.8 2c-1.9-2.5-3.7-5.1-5.6-7.7-1.8 2.6-3.7 5.2-5.6 7.7l-2.8-1.9 3.6-4.7h-8.6v10h26.8z m0 8.2v-3.2h-26.8v3.2h26.8z m-18.4-25c-0.9 0-1.6 0.8-1.6 1.8s0.7 1.6 1.6 1.6 1.6-0.7 1.6-1.6-0.7-1.8-1.6-1.8z m10 0c-0.9 0-1.6 0.8-1.6 1.8s0.7 1.6 1.6 1.6 1.6-0.7 1.6-1.6-0.7-1.8-1.6-1.8z m8.4 3.4c1.8 0 3.2 1.5 3.2 3.4v18.2c0 1.9-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.5-3.2-3.4v-18.2c0-1.9 1.4-3.4 3.2-3.4h3.7c-0.1-0.5-0.3-1.1-0.3-1.6 0-2.8 2.3-5 5-5 1.7 0 3.2 0.8 4.1 2.1l0.9 1.2 0.9-1.2c0.9-1.3 2.4-2.1 4.1-2.1 2.7 0 5 2.2 5 5 0 0.5-0.2 1.1-0.3 1.6h3.7z' })
        )
    );
};

exports.default = MdRedeem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/redeem.js
// module id = 3219
// module chunks = 0